import { saveApostaSimples } from "./getApostasSimples";

export function getApostaPendente() {
    if(localStorage && localStorage.getItem("saved-aposta")) return JSON.parse(localStorage.getItem("saved-aposta"));
    return undefined;
}

/**
 * @param {Aposta[]} newList
 */
export function setApostaPendente(newAposta) {
    const oldAposta = getApostaPendente();
    if(localStorage) localStorage.setItem("saved-aposta", JSON.stringify(newAposta));
    if(oldAposta) saveApostaSimples(oldAposta);
}

export function deleteApostaPendente(){
    if(localStorage) localStorage.removeItem("saved-aposta");
}

export function getApostas() {
    if (localStorage && localStorage.getItem("saved-apostas")) return JSON.parse(localStorage.getItem("saved-apostas"));
    return undefined;
}

/**
 * @param {Aposta[]} newList
 */
export function setApostas(newList) {
    if (localStorage) localStorage.setItem("saved-apostas", JSON.stringify(newList));
}

export function clearApostas() {
    return setApostas([]);
}

export function deleteAposta(index) {
    const newList = getApostas();
    newList.splice(index, 1);
    return setApostas(newList);
}


// WEBPACK FOOTER //
// ./src/utils/getApostaPendente.js